module.exports = __webpack_public_path__ + "static/media/3.20433aa2.jpg";